import '../styles/Investors.css';
import IconLetter from '../assets/icon-letter.png';
import IconCircular from '../assets/icon-circular.png';
import IconFAQ from '../assets/icon-faq.png';
import IconVote from '../assets/icon-vote.png';
import { Breadcrumb } from 'semantic-ui-react';
import FactSheet from '../assets/Fact_Sheet.pdf';
import ShareholderMeetingCircular from '../assets/ShareholderMeetingCircular.pdf';
import ShareholderMeetingLetter from '../assets/ShareholderMeetingLetter.pdf';
import ShareholderMeetingFAQ from '../assets/ShareholderMeetingFAQ.pdf';
import ShareholderMeetingVote from '../assets/ShareholderMeetingVote.pdf';
import { Container, Row, Col, Card } from 'react-bootstrap'

require('dotenv').config();

const breadcrumbSections = [
    { key: 'home', content: 'HOME', href: "/" },
    { key: 'specialmeeting', content: 'SPECIAL MEETING', active: true },

]

function SpecialMeeting() {


    return (
        <>
            <div style={{ textAlign: 'left', marginLeft: '70px', marginTop: '80px' }}>
                <Breadcrumb icon='right angle' sections={breadcrumbSections} style={{ backgroundColor: '#fff' }} />
            </div>

            <div className="investors-header" >
                <h2 style={{ color: '#0D1643', fontSize: '2rem !important' }}><b>Special Meeting of Shareholders</b></h2>
            </div>

            <div className="investors-content ">
                <Container fluid>
                    <Row className="align-items-center ">
                        <div id="inventor-top">
                            <div className="icons-list-align-left" >
                                <ul>
                                    <li>
                                        <a href={ShareholderMeetingLetter} target="_blank"><img className="investor-icons" src={IconLetter} alt="Link to Letter to Shareholders" />Letter to Shareholders</a> 
                                    </li>
                                    <li>
                                        <a href={ShareholderMeetingCircular} target="_blank"><img className="investor-icons" src={IconCircular} alt="Link to Management Information Circular" />Management Information Circular  </a> 
                                    </li>
                                    <li>
                                        <a href={ShareholderMeetingFAQ} target="_blank"><img className="investor-icons" src={IconFAQ} alt="Link to Shareholder FAQ" />Shareholder FAQ</a> 
                                    </li>
                                    <li>
                                        <a href={ShareholderMeetingVote} target="_blank"><img className="investor-icons" src={IconVote} alt="Link to How to Vote" />How to Vote</a> 
                                    </li>
                                </ul>
                            </div> 
                            <div className="tradingview-widget-container" >
                                <div style={{textAlign: "left"}}>
                                    <h3>March 10th 2026 at 9:00 AM (Toronto Time)</h3> 

                                    <h3 style={{color: "#ff842f"}}>YOUR VOTE IS IMPORTANT.</h3>

                                    <h4>Vote well in advance of the proxy voting deadline on <b>March 6th 2026 at 9:00 a.m.</b> (Toronto Time).</h4>

                                    <h4>
                                        The Board of Directors of Titanium Transportation Group Inc. unanimously recommends <br/>
                                        that shareholders vote <u style={{color: "#ff842f"}}>FOR </u> the Arrangement Resolution.
                                    </h4>

                                    <br/>
                                    <hr style={{border: "2px solid black", backgroundColor: "black"}}/>

                                    <h3 style={{color: "#ff842f"}}>Shareholder Questions</h3>

                                    <h4>Shareholders who have questions or require voting assistance may contact Titanium Transportation’s proxy solicitation agent.</h4>

                                    <h3 style={{marginBottom: "-20px"}}>
                                        <b>Laurel Hill Advisory Group</b>
                                    </h3> 
                                    <h4>
                                        Canada/US Toll Free: 1-877-452-7184 <br/>
                                        International: 1-416-304-0211 <br/>
                                        Text Message: Text "INFO" to 416-304-0211 or 1-877-452-7184 <br/>
                                        Email: assistance@laurelhill.com
                                    </h4> 
                                    <br/>
                                </div>
                            </div>                           
                        </div>
                    </Row>
                </Container>
            </div>          
        </>
    )
}

export default SpecialMeeting
